"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = void 0;
const utils_1 = require("@tria-sdk/utils");
const helper_1 = require("../utils/helper");
const constants_1 = require("../utils/constants");
const config_1 = require("../utils/config");
const decrypt = (calldata, dappDetails, authUrl = constants_1.triaAuthUrl, environment = 'mainnet') => __awaiter(void 0, void 0, void 0, function* () {
    if ((0, helper_1.wagmiConnected)()) {
        const wallet = new utils_1.WalletController({
            baseUrl: config_1.apiUrl[environment],
            walletType: { embedded: false },
            selectedChainName: calldata.chainName,
            environment,
        });
        const res = yield wallet.decrypt(calldata.encryptedData);
        return res;
    }
    else if ((0, helper_1.triaConnected)()) {
        const iframeEncodedData = (0, helper_1.createEncodedData)(Object.assign(Object.assign(Object.assign({}, calldata), { environment }), dappDetails));
        // console.log('encoded', iframeEncodedData, calldata, dappDetails);
        const decryptIframeUrl = `${authUrl}/decrypt/${iframeEncodedData}`;
        (0, helper_1.createIframe)(decryptIframeUrl, 'decrypt');
        return new Promise((resolve, reject) => {
            const listener = (e) => {
                var _a;
                if (e.origin !== authUrl)
                    return;
                let eventData;
                try {
                    eventData = JSON.parse(e.data);
                }
                catch (err) {
                    eventData = e.data;
                }
                if ((eventData === null || eventData === void 0 ? void 0 : eventData.type) === 'closeIframe' && (eventData === null || eventData === void 0 ? void 0 : eventData.callFrom) === 'decrypt') {
                    // console.log('event', eventData);
                    (_a = document.getElementById('decrypt')) === null || _a === void 0 ? void 0 : _a.remove();
                    window.removeEventListener('message', listener);
                    resolve(eventData === null || eventData === void 0 ? void 0 : eventData.data);
                }
            };
            window.addEventListener('message', listener);
        });
    }
    else {
        return { success: false, message: 'Metamask and Tria not connected!' };
    }
});
exports.decrypt = decrypt;
